import { MessageSquare, FileText, Calculator, ShieldCheck } from "lucide-react";

const STEPS = [
  {
    icon: MessageSquare,
    title: "Share your need",
    desc: "Tell us what you want to insure — car, family, truck, tractor, travel or business.",
  },
  {
    icon: Calculator,
    title: "Compare quotes",
    desc: "We compare premiums across top insurers and shortlist the best plans for you.",
  },
  {
    icon: FileText,
    title: "Pick & pay",
    desc: "Choose the right plan, fill simple details and pay securely — get policy on email.",
  },
  {
    icon: ShieldCheck,
    title: "Stay protected",
    desc: "Relax — your renewal reminders and claim support are handled by our team.",
  },
];

export default function HowItWorks() {
  return (
    <section id="how" data-testid="how-section" className="py-16 md:py-24 bg-[#0f172a] text-white">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <div className="max-w-2xl">
          <span className="eyebrow">Simple 4-step process</span>
          <h2 className="font-display mt-4 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight">
            From quote to cover —<br /> in under <span className="text-[#f5b942]">15 minutes.</span>
          </h2>
          <p className="font-hindi mt-3 text-lg text-slate-300">
            तेज़, आसान और भरोसेमंद बीमा खरीदने की प्रक्रिया।
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {STEPS.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={s.title}
                data-testid={`how-step-${i}`}
                className="relative p-6 rounded-2xl bg-white/5 border border-white/10 backdrop-blur-sm hover:bg-white/10 transition-all"
              >
                <div className="absolute -top-4 -left-2 font-display text-7xl font-extrabold text-[#f5b942]/20 leading-none select-none">
                  {i + 1}
                </div>
                <div className="relative">
                  <div className="w-12 h-12 rounded-xl bg-[#f5b942] flex items-center justify-center">
                    <Icon className="w-5 h-5 text-slate-900" />
                  </div>
                  <h3 className="font-display mt-4 text-xl font-bold">
                    {s.title}
                  </h3>
                  <p className="mt-2 text-sm text-slate-300 leading-relaxed">
                    {s.desc}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
